function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  fill: "#183150",
  fillOpacity: .5,
  d: "M18 13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5.28l7.48 4.57a1 1 0 0 0 1 0L18 5.28zM3 2h14a1 1 0 0 1 1 1l-8 4.88L2 3a1 1 0 0 1 1-1zm14-2H3a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/email.7f63f244.svg";
export { SvgComponent as ReactComponent };